/* eslint-disable @typescript-eslint/no-explicit-any */
import { dateFormats } from '@nextinq/domain';
import React from 'react';

export function TicketItem(props: any) {
  if (!props.number) {
    return <span>???</span>;
  }
  return (
    <li>
      {props.number} - pin: <em>{props.pin || '?????'}</em>, created:{' '}
      {dateFormats.short.dateTime(props.createdOn)}
    </li>
  );
}

export default function TicketList(props: any) {
  if (!props.items) {
    return null;
  }
  return (
    <ul>
      {props.items.map((ticket: any) => (
        <TicketItem key={ticket.uuid} {...ticket} />
      ))}
    </ul>
  );
}
